import { Link } from 'react-router-dom';
import pressRelease from '../static/pdf/De School Press Release.pdf';

const Footer = (props) => {
  const code = <span>Code&nbsp;of&nbsp;Conduct</span>
  return (
          <footer className="footer__container">
       {/* <div className="footer__row">
          <div className="footer__item ff">Jan van Breemenstraat 1, Amsterdam</div>
          <div className="footer__item ff">020-7373197</div>
          <a href="mailto:info@deschoolamsterdam.nl" className="footer__item footer__link ff" title="info@deschoolamsterdam.nl">info@deschoolamsterdam.nl</a>
        </div>*/}


      <div className="footer__row footer__link-row">

        {/*<a  className="footer__link ff"  target="_blank" rel="noreferrer" href={pressRelease}>{props.isNL ? 'Persbericht' : 'Press Release'}</a>*/}
         <span>  &nbsp;  </span>
        <Link to="/house-rules" className="footer__link ff">{props.isNL ? 'Huisregels' : 'House Rules'}</Link>
        <span>  &nbsp;  </span>
        <Link to="/code-of-conduct" className="footer__link ff">{props.isNL ? 'Gedragscode' : code}</Link>
        <span>  &nbsp;  </span>
        </div>
{/*         <Link to="/timeline" className="footer__link ff">{props.isNL ? 'Tijdlijn' : 'Timeline'}</Link>
      </div><span>  &nbsp;  </span>*/}
       <div className="footer__row footer__link-row">
        <Link to="/contact" className="footer__link ff">Contact</Link>
        <span>  &nbsp;  </span>
        <Link to="/terms-and-conditions" className="footer__link ff">{props.isNL ? 'Algemene Voorwaarden' : 'Terms & Conditions'}</Link>
        <span>  &nbsp;  </span>
        <Link to="/disclaimer" className="footer__link ff">Disclaimer</Link>
        <span>  &nbsp;  </span>
        <Link to="/colophon" className="footer__link ff">{props.isNL ? 'Colofon' : 'Colophon'}</Link>


       {/* <span>  &nbsp;  </span>
                <Link to="/privacy-policy" className="footer__link ff">Privacy Policy</Link>*/}
       {/* <span>  &nbsp;  </span>
        <br/>

        <span>  &nbsp;  </span>

        <span>  &nbsp;  </span>*/}



        </div>

    </footer>
    );
};

export default Footer;
